import React, { useState, useEffect } from "react";
import {
  TrendingUp,
  TrendingDown,
  Factory,
  DollarSign,
  BarChart3,
  Calendar,
  Menu,
  Bell,
  PieChart,
} from "lucide-react";

import * as Icon from "react-bootstrap-icons";

import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart as RePieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import {BsecDashboard} from '../components';
import configData from "../config.json";
import axios from "axios";
import { useNavigate } from "react-router-dom";


const COLORS = ["#0d6efd", "#198754", "#dc3545"];

const DashboardCard = ({
  title,
  current,
  previous,
  cumulative,
  PYcumulative,
  icon,
  color,
}) => {
  const growth = (((current - previous) / previous) * 100).toFixed(1);
  const cumGrowth = (((cumulative - PYcumulative) / PYcumulative) * 100).toFixed(1);

  return (
    <div style={{ background: "#fff", borderRadius: "15px", padding: "20px", boxShadow: "0 4px 15px rgba(0,0,0,0.08)",}} >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
        <div>
          <div style={{ display: "flex", justifyContent: "space-between",}}>
              <p style={{ color: "#6c757d", marginBottom: "10px" }}>{title} <small>(Amount In Crore)</small></p>
          </div>
          <div >
            <h4 style={{ margin: 0, color: "#069406" }}>Current:{Number(current/100).toFixed(2)}</h4>
            <h4 style={{ margin: 0, color: "#3773f4" }}>Previous:{Number(previous/100).toFixed(2)}</h4>
            {/* <h2 style={{ margin: 0 }}>{Number(current/100).toFixed(2)}/{Number(previous/100).toFixed(2)}</h2> */}
            {/* <p style={{ color: growth > 0 ? "green" : "red", marginTop: "10px", fontWeight: "bold", }}>
              {growth}% from previous year
            </p> */}
          </div>

        </div>

        <div style={{ background: color, color: "#fff", padding: "15px", borderRadius: "12px",}}>
          {icon}
        </div>
      </div>

      <hr />

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px",}}>

        <div style={{ textAlign: "left" }}>
          <small>Cumulative</small>
          <h5>{Number(cumulative/100).toFixed(1)}</h5>
        </div>

        <div style={{ textAlign: "right" }}>
          <small>Previous Year Cumulative</small>
          <h5>{Number(PYcumulative/100).toFixed(1)}</h5>
        </div> 
      </div>
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px",}}>
            <p style={{ color: cumGrowth > 0 ? "green" : "red", marginTop: "10px", fontWeight: "bold", }}>
              {cumGrowth}% from previous year
            </p>
      </div> */}
    </div>
  );
};

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [misData,setMisData]=useState([]);
  const [misDataSum,setMisDataSum]=useState([]);
  const navigate = useNavigate();

  useEffect(() => {
        const getMisData = async () => {
          const response=await axios.get(configData.SERVER_URL+`/bsecmisDashboard/${localStorage.getItem('branchID')}`)
          setMisData(response.data);
        };
        getMisData();
  
  }, []);

  const summaryData = [
  
  {
    title: "Production",
    current: misData.reduce((a, b) => a + Number(b.proValue || 0), 0),
    previous: misData.reduce((a, b) => a + Number(b.preProValue || 0), 0),
    cumulative: misData.reduce((a, b) => a + Number(b.cumProValue || 0), 0),
    pyCumulative: misData.reduce((a, b) => a + Number(b.cumPreProValue || 0), 0),
  },
  {
    title: "Sales",
    current: misData.reduce((a, b) => a + Number(b.salesValue || 0), 0),
    previous: misData.reduce((a, b) => a + Number(b.preSalesValue || 0), 0),
    cumulative: misData.reduce((a, b) => a + Number(b.cumSalesValue || 0), 0),
    pyCumulative: misData.reduce((a, b) => a + Number(b.cumPreSalesValue || 0), 0),
  },
  {
    title: "Profit",
    current: misData.reduce((a, b) => a + Number(b.profitLoss || 0), 0),
    previous: misData.reduce((a, b) => a + Number(b.preProfitLoss || 0), 0),
    cumulative: misData.reduce((a, b) => a + Number(b.cumProfitLoss || 0), 0),
    pyCumulative: misData.reduce((a, b) => a + Number(b.cumPreProfitLoss || 0), 0),
  },
];

  return (
    <div style={{display: "flex", minHeight: "100vh", background: "#f4f6f9", fontFamily: "Arial" }} >
      
      {/* Main */}
      <div style={{ flex: 1 }}>

        <div style={{ padding: "25px" }}>
          {/* Dashboard Cards */}
          <div style={{  display:"grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: "20px",}}>
            {summaryData.map((summaryData, index) => (
            <div key={index}>
              <DashboardCard
              title={summaryData.title}
              current={summaryData.current}
              previous={summaryData.previous}
              cumulative={summaryData.cumulative}
              PYcumulative={summaryData.pyCumulative}
              color= {(summaryData.current<summaryData.previous) ?"#ef3208":"#0ca90c"}
              icon={(summaryData.current<summaryData.previous) ?<TrendingDown size={30} />:<TrendingUp size={30} />}
              />
            </div>
            ))}

          </div>

        </div>
        
      </div>
    </div>
  );
};

export default Dashboard;